"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useFormValidator;

var _react = require("react");

var _Editor = require("./Editor");

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function getInitialValue(getState, check) {
  var state = getState();

  if (typeof check === 'function') {
    return check(state);
  }

  return state[check];
}

function useFormValidator(check, validator) {
  var _useEditor = (0, _Editor.useEditor)(),
      getState = _useEditor.getState,
      subscribe = _useEditor.subscribe,
      validate = _useEditor.validate;

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      error = _useState2[0],
      setError = _useState2[1];

  (0, _react.useEffect)(function () {
    if (!validator) return undefined;
    var original = getInitialValue(getState, check);
    var currentValidation = 0;
    var validation = validate(check, function (value) {
      if (typeof validator === 'string') {
        if (!value) {
          setError(validator);
          return false;
        }

        setError(null);
        return true;
      } // Keep track for async validators, which
      // might become obsolete when values change
      // faster than the validation is completed
      // think ajax based validations


      currentValidation += 1;
      var vl = currentValidation;

      try {
        var res = validator(value); // Support asynchrnous validation

        if (!res || !res.then) {
          setError(null);
          return true;
        }

        return res.then(function () {
          if (vl === currentValidation) {
            setError(null);
          }

          return true;
        })["catch"](function (err) {
          if (vl === currentValidation) {
            setError(err.message);
          }

          return false;
        });
      } catch (err) {
        setError(err.message);
        return false;
      }
    });

    function handler(value) {
      if (value !== original) {
        original = value;
        validation.run(value);
      }
    }

    var unsub = subscribe(check, handler);
    return function () {
      currentValidation = null;
      validation.remove();
      unsub();
    }; // The context values are kept constant for the entire
    // life of the component, so ignoring those values
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [check, validator]);
  return error;
}